<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="800_auto"
      no-padding
  >
    <template #header>
      预览结果
    </template>
    <template #content>
      <div style="padding: 16px 20px 0 20px;">

        <!--        radio-->
        <gj-radio-group size="mini" v-model="type" :options="typeGroup"></gj-radio-group>

        <!--        提示框-->
        <gj-alert type="info" show-icon style="margin: 12px 0;">
          <template #title>
            <div>预期结果仅提供参考，不作为最终的执行结果；</div>
            <div>预算或竞价降低时，按规则计算的调整值，低于亚马逊最低的预算或竞价，将调整为亚马逊限制的最低价。</div>
          </template>
        </gj-alert>

<!--        调整竞价-->
        <app-ad-preview-table
            v-show="type===1"
            :data="form.bidForm"
            :type="1"
            :defaultNum="basicPrice[0]"
        ></app-ad-preview-table>

<!--        调整广告位竞价-->
        <app-ad-preview-placement-table
            v-show="type===2"
            :data="form.placementBidForm"
        ></app-ad-preview-placement-table>

<!--        调整每日预算-->
        <app-ad-preview-table
            v-show="type===3"
            :data="form.budgetForm"
            :type="3"
            :defaultNum="basicPrice[1]"
        ></app-ad-preview-table>

      </div>
    </template>
    <template #footer>
      <gj-button
          @click="cancel">
        关闭
      </gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import AppAdPreviewTable from "./ad-preview-table"
import AppAdPreviewPlacementTable from "./ad-preview-placement-table"

export default {
  name: "ad-preview-modal",
  mixins: [modalMixIn],
  components: {AppAdPreviewTable,AppAdPreviewPlacementTable},
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    strategy: null, //默认选中的tab
    strategyType:null, //用于区分从哪个父级模块大概此modal
    defaultNum:null, //默认基础值
  },
  created() {
    this.type = this.strategy;
    // 从广告活动进入 设置基础预算
    if(this.strategyType === 3){
      this.basicPrice[1] = this.defaultNum
    }
    // 从广告组、关键词、商品投放、投放组进入  设置基础竞价
    else if(this.strategyType === 1){
      this.basicPrice[0] = this.defaultNum
    }
  },
  data() {
    return {

      // 基础竞价、基础预算
      basicPrice:[1,20],

      // 当前选中的类型
      type: 1,
      // 类型option
      typeGroup: [
        {id: 1, text: '调整竞价'},
        {id: 2, text: '调整广告位竞价'},
        {id: 3, text: '调整每日预算'}
      ],

      tableData: [],
      // 表格配置
      columns: [
        {id: 'frequency', header: '频率（站点时间）', field: 'slot:frequency', width: '180px'},
        {id: 'price', header: 'slot:price', field: 'slot:price', minWidth: '300px'},
        {id: 'results', header: 'slot:results', field: 'slot:results', width: '160px'},
      ]
    }
  },
}
</script>

<style scoped>

</style>